import { CloseOutlined } from '@ant-design/icons';
import AppButton from '@nxsys/components/AppButton';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form, Typography } from 'antd';
import { FormProps } from 'antd/lib';
import React from 'react';
import AppRateInput from '@nxsys/components/AppRateInput';

type EarningReportFilterProps = {
  isOpen: boolean;
  toggle: () => void;
  onFilter: (params: EarningReportFilterValues) => void;
};

export type EarningReportFilterValues = {
  taxPeriodFrom: number;
  taxPeriodTo: number;
};

const EarningReportFilterModal: React.FC<EarningReportFilterProps> = ({
  isOpen,
  toggle,
  onFilter,
}: EarningReportFilterProps) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm();
  const watchValue = Form.useWatch([], form);
  const ableToClearFilter =
    watchValue && Object.keys(watchValue).some((key) => !!watchValue[key]);

  const handleClearAll = (e: React.MouseEvent) => {
    e.stopPropagation();
    form.resetFields();
  };

  const onFinish: FormProps['onFinish'] = (values) => {
    onFilter(values);
    toggle();
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={messages['common.filter']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.apply'],
          buttonType: 'primary',
          onClick: () => form.submit(),
        },
      ]}
      closeIcon={
        <div style={{ marginRight: 90 }}>
          <AppButton
            name={messages['common.clearAll']}
            leftIcon={<CloseOutlined />}
            onClick={handleClearAll as any}
            disabled={!ableToClearFilter}
          />
        </div>
      }
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Typography.Text>{messages['common.taxPeriod']}</Typography.Text>
        <div className="grid grid-cols-2  gap-x-4 mt-2">
          <Form.Item name="taxPeriodFrom">
            <AppRateInput placeholder={messages['common.from']} />
          </Form.Item>
          <Form.Item name="taxPeriodTo">
            <AppRateInput placeholder={messages['common.to']} />
          </Form.Item>
        </div>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default EarningReportFilterModal;
